export type MoverTab = "today" | "jobs" | "availability" | "pay";

type Props = {
  active: MoverTab;
  onChange: (tab: MoverTab) => void;
};

const TABS: { key: MoverTab; label: string; icon: string }[] = [
  { key: "today", label: "Today", icon: "ri-time-line" },
  { key: "jobs", label: "Jobs", icon: "ri-truck-line" },
  { key: "availability", label: "Schedule", icon: "ri-calendar-line" },
  { key: "pay", label: "Pay", icon: "ri-money-dollar-circle-line" },
];

export default function MoverTabBar({ active, onChange }: Props) {
  return (
    <nav className="sticky bottom-0 bg-white border-t border-ink-100 px-2 pt-2 pb-3 grid grid-cols-4 gap-1 z-30">
      {TABS.map((t) => {
        const isActive = t.key === active;
        return (
          <button
            key={t.key}
            onClick={() => onChange(t.key)}
            className={`flex flex-col items-center gap-0.5 py-2 rounded-lg cursor-pointer transition-colors ${
              isActive ? "text-brand-700" : "text-ink-500 hover:text-ink-900"
            }`}
          >
            <span
              className={`w-9 h-9 flex items-center justify-center rounded-lg transition-colors ${
                isActive ? "bg-brand-100" : ""
              }`}
            >
              <i className={`${t.icon} text-lg`}></i>
            </span>
            <span className="text-[10px] font-bold uppercase tracking-wider">{t.label}</span>
          </button>
        );
      })}
    </nav>
  );
}